import { isNullOrUndefined } from '@/utils/comparators'

/**
* Returns true if the user has downloaded the app
*/
const hasApp = (state) => {
  return !isNullOrUndefined(state.hasApp) ? state.hasApp : false
}

/**
* Returns true if the user has bought a limited deal
*/
const hasBoughtDeal = (state) => {
  return !isNullOrUndefined(state.hasBoughtDeal) ? state.hasBoughtDeal : false
}

/**
* Returns true if the user has created local numbers
*/
const hasLocalNumber = (state) => {
  return !isNullOrUndefined(state.hasLocalNumber) ? state.hasLocalNumber : false
}

/**
* Returns true if the user has world credits on the account
*/
const hasRebtelCredit = (state) => {
  return !isNullOrUndefined(state.hasRebtelCredit) ? state.hasRebtelCredit : false
}

/**
* Returns true if the user has access to recharge service
*/
const hasRecharge = (state) => {
  return !isNullOrUndefined(state.hasRecharge) ? state.hasRecharge : false
}

/**
* Returns true if the user comes from a country where Rebtel has local numbers
*/
const inRebtelCountry = (state) => {
  return !isNullOrUndefined(state.inRebtelCountry) ? state.inRebtelCountry : false
}

/**
* Returns true if the user has a rebtel SIM card
*/
const hasSim = (state) => {
  return !isNullOrUndefined(state.hasSim) ? state.hasSim : false
}

/**
* Returns true if the user is an Activist
*/
const isActivist = (state) => {
  return !isNullOrUndefined(state.isActivist) ? state.isActivist : false
}

export default {
  hasApp,
  hasBoughtDeal,
  hasLocalNumber,
  hasRebtelCredit,
  hasRecharge,
  inRebtelCountry,
  hasSim,
  isActivist
}



// WEBPACK FOOTER //
// ./src/store/modules/user/behavior/getters.js